import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('wellnessTracker_currentUser');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setIsLoading(false);
  }, []);

  const login = (username, password) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const users = JSON.parse(localStorage.getItem('wellnessTracker_users') || '{}');
        
        if (users[username] && users[username].password === password) {
          const userInfo = { username, id: users[username].id };
          setUser(userInfo);
          localStorage.setItem('wellnessTracker_currentUser', JSON.stringify(userInfo));
          resolve(userInfo);
        } else {
          reject(new Error('Invalid username or password'));
        }
      }, 500);
    });
  };

  const register = (username, password) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const users = JSON.parse(localStorage.getItem('wellnessTracker_users') || '{}');
        
        if (users[username]) {
          reject(new Error('Username already exists'));
          return;
        }

        const newUser = {
          id: Date.now().toString(),
          password,
          createdAt: new Date().toISOString()
        };
        
        users[username] = newUser;
        localStorage.setItem('wellnessTracker_users', JSON.stringify(users));
        
        const userInfo = { username, id: newUser.id };
        setUser(userInfo);
        localStorage.setItem('wellnessTracker_currentUser', JSON.stringify(userInfo));
        resolve(userInfo);
      }, 500);
    });
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('wellnessTracker_currentUser');
  };

  const value = {
    user,
    login,
    register,
    logout,
    isLoading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};